const COLUMNS = ['grid-cols-1', 'grid-cols-2', 'grid-cols-3', 'grid-cols-4'];

export const socialGridColumnsClassName = (count: number) =>
  COLUMNS[count - 1] ?? 'grid-cols-3';
